import { ConvertMillimetersToCentimeters, ConvertCentimetersToMillimeters } from '@/utils/converters';
import request from '@/utils/request';

function transformItem2Dto(item) {
  const dto = {
    ...item,
    workshopID: item.id,
    maximumProcessingHeightInMm: ConvertCentimetersToMillimeters(item.maximumProcessingHeight)
  };
  delete dto.id;
  delete dto.maximumProcessingHeight;
  return dto;
}

function transformDto2Item(dto) {
  const item = {
    ...dto,
    id: dto.workshopID,
    maximumProcessingHeight: ConvertMillimetersToCentimeters(dto.maximumProcessingHeightInMm)
  };
  delete item.workshopID;
  delete item.maximumProcessingHeightInMm;
  return item;
}
function getCountriesUsedInWorkshops() {
  return request({
    method: 'get',
    url: 'workshop/getCountriesUsedInWorkshops'
  });
}

export const storeExtensions = {
  actions: {
    getCountriesUsedInWorkshops({ dispatch }) {
      return new Promise((resolve, reject) =>
        getCountriesUsedInWorkshops()
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          })
      );
    }
  }
};

export const apiOverrides = { transformItem2Dto, transformDto2Item };
